import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'MyArable',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'My Arable',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl, IETFLocales.en, IETFLocales.de, IETFLocales.fr],
  PRODUCTION: true,
  AZURE_MAPS_SUBSCRIPTION_KEY: 'dcBP1s64SFNCvQpGOQx0_MQT8xHbM1ec8Vah8_5EnrE',
  AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: 'dcBP1s64SFNCvQpGOQx0_MQT8xHbM1ec8Vah8_5EnrE',
  FERTIGATION_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  FERTIGATION_DASHBOARD_REPORT_ID: 'fb803906-bd2c-4710-9bea-1a57f07b0423',
  VIRUS_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  VIRUS_DASHBOARD_REPORT_ID: 'b350bef4-4ff0-43e7-9357-55f26387d460',
  TGA_POTATO_SEED_STARCH_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_POTATO_SEED_STARCH_DASHBOARD_REPORT_ID: '74a135f8-1209-4de7-b1fe-c7ee7331c0b3',
  TGA_ONION_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_ONION_DASHBOARD_REPORT_ID: '539c5f23-52cb-4c11-bf3b-03f23400a968',
  TGA_GENERAL_INFORMATION_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_GENERAL_INFORMATION_DASHBOARD_REPORT_ID: '54f6b2f8-bb4a-4fb0-95ac-da1123ddb936',
  TGA_FERTILIZER_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_FERTILIZER_DASHBOARD_REPORT_ID: '83144534-3a84-4732-8f9e-944954a36a5c',
  TGA_PHYTOPHTHORA_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_PHYTOPHTHORA_DASHBOARD_REPORT_ID: '5b32e816-80d8-4621-9fc7-98c3f44236ad',
  TGA_VELDWAARNEMINGEN_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  TGA_VELDWAARNEMINGEN_DASHBOARD_REPORT_ID: 'bb714966-ea33-48db-b839-be9502f9eece',
  SHOW_DOWNY_MILDEW_DASHBOARD_WIDGET: false,
  SHOW_VIRUS_MONITOR_DASHBOARD_WIDGET: false,
  SHOW_SYNC_FROM_EXTERNAL_FARM_PROVIDER_BUTTON: false,
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  SHOP_URL: 'https://webshop.agrifirm.com',
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  KUBE_CONTAINER_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_POD_NAME: '',
  KUBE_TEAM: '',
  SHOW_CART_ICON: true,
  DELIVERY_TIME_WINDOW_DISABLED: true,
  SHOW_DISABLED_LOCATION_BADGE: true,
  SUBSCRIBE_TO_CART_EVENTS: true,
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
  PRE_SALES_REBUILD_DONE: true,
};
